import { render, staticRenderFns } from "./MainLayoutMenu.vue?vue&type=template&id=43a348a2&"
import script from "./MainLayoutMenu.vue?vue&type=script&lang=ts&"
export * from "./MainLayoutMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MainLayoutMenu.vue?vue&type=style&index=0&id=43a348a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports